// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

export default {
  Taxonomy: {
    EditNode: 'Modifier l’ingrédient',
    Save: 'Enregistrer',
    Saved: 'L’ingrédient a été modifié.',
    Active: 'Actif (décocher pour archiver)',
    Archived: 'Archivé',

    Title: 'Ingrédients',
    Subtitle: 'Explorez les classes et leurs annotations validées, puis enrichissez le référentiel d’ingrédients.',
    Search: 'Rechercher un nom ou un code',
    Restaurant: 'Restaurant',
    AllRestaurants: 'Tous mes restaurants',
    Project: 'Projet',
    AllProjects: 'Tous les projets',
    AnnotationType: 'Type d’annotation',
    BboxOnly: 'BBox',
    MaskOnly: 'Masques',
    BothTypes: 'BBox et masques',
    Depth: 'Profondeur',
    Level: 'Niveau {{level}}',
    Reset: 'Réinitialiser la vue',
    Refresh: 'Actualiser',
    Loading: 'Chargement de le référentiel d’ingrédients',
    MapLabel: 'Carte de le référentiel d’ingrédients',
    NoResults: 'Aucun nœud ne correspond à cette recherche.',
    Empty: 'Le référentiel d’ingrédients est vide. Importez le référentiel pour commencer.',
    NoBranches: 'Aucune branche pour le moment. Ajoutez un nœud sous la racine.',
    LoadError: 'Impossible de charger le référentiel d’ingrédients.',
    StatsError: 'Les compteurs d’annotations sont indisponibles.',
    CountsUnavailable: 'Annotations : —',
    Retry: 'Réessayer',
    Classes_one: '{{count}} classe descendante',
    Classes_other: '{{count}} classes descendantes',
    Annotations_one: '{{formatted}} annotation validée',
    Annotations_other: '{{formatted}} annotations validées',
    CountHelp:
      'Classes : descendants actifs sélectionnables, hors nœud courant. Annotations : affectations validées du nœud et de ses descendants actifs, selon le restaurant, le projet et le type choisis. Ces volumes ne sont pas des images uniques.',
    Expand: 'Déplier',
    Collapse: 'Replier',
    Details: 'Détail de l’ingrédient',
    SelectNode: 'Sélectionnez un nœud pour consulter sa définition, son chemin et ses volumes.',
    NoDefinition: 'Aucune définition renseignée.',
    AnnotationDetails: 'Répartition des annotations validées',
    ValidatedAnnotations: 'Annotations validées',
    Direct: 'Nœud seul',
    Subtree: 'Nœud et descendants',
    BboxAssignments: 'Affectations bbox',
    Masks: 'Masques',
    AddNode: 'Ajouter un ingrédient',
    AddChild: 'Ajouter un enfant',
    Parent: 'Ingrédient parent',
    Name: 'Nom',
    Code: 'Code',
    Definition: 'Définition',
    Selectable: 'Sélectionnable pour l’entraînement',
    NotSelectable: 'Non sélectionnable',
    CodeHelp: 'Code unique et immuable : lettres majuscules, chiffres et tirets bas, commençant par une lettre.',
    NameInvalid: 'Saisissez un nom de 1 à 256 caractères.',
    CodeInvalid: 'Utilisez un code de 1 à 128 caractères : A–Z, 0–9 et _, commençant par une lettre.',
    CodeExists: 'Ce code existe déjà, éventuellement sur un nœud archivé.',
    ParentRequired: 'Sélectionnez un parent actif et existant.',
    ImportRequired: 'Importez le référentiel d’ingrédients avant d’ajouter des nœuds.',
    SaveError: 'Impossible de créer le nœud. Vérifiez votre accès puis réessayez.',
    Created: 'Le nœud a été créé.',
    Cancel: 'Annuler',
    Create: 'Créer',
    Saving: 'Création…',
  },
  PipelineComparisons: {
    ScoreUnavailable: 'score indisponible',
    Pair: 'Paire {{pair}} · IoU {{iou}}',
    Unmatched: 'Sans correspondance',
    BoxCount: '{{count}} bbox',
    Reload: 'Recharger',
    ImageLoadError: 'Impossible de charger l’image. Recharger renouvelle son URL d’accès.',
    NoResult: 'Aucun résultat pour le moment.',
    PreviousImage: 'Précédente',
    NextImage: 'Suivante',
    ImagePosition: 'Image {{current}} / {{total}}',
    LoadingImages: 'Chargement…',
    ImageThumbnails: 'Miniatures des images',
    SelectImage: 'Image {{id}} — {{status}}',
    OpenAnnotationWorkspace: 'Ouvrir cette image dans Annotation Workspace ↗',
    ImageNavigationHint: 'Cliquez sur une miniature ou utilisez les flèches ← → pour parcourir les images filtrées.',

    Candidate: 'Pipeline candidate',
    NewComparison: 'Nouvelle comparaison',
    SavedRuns: 'Runs sauvegardés',
    NoRuns: 'Aucun run sauvegardé. Créez une comparaison pour commencer.',

    Comparison: 'Comparaison',
    Disagreement: 'Désaccord',
    Title: 'Comparaisons de pipelines',
    View: 'Étapes affichées',
    Detection: 'Détection',
    Classification: 'Classification vrac',
    AllStages: 'Ensemble',
    reference: 'Pipeline A — référence',
    candidate: 'Pipeline B — candidate',
    StoredReference: 'Résultats sauvegardés',
    DetectionModel: 'Clé du détecteur',
    ClassificationModel: 'Clé du classifieur vrac',
    Threshold: 'Seuil vrac (strict)',
    ActualModel: 'Détecteur utilisé',
    SharedDetection: 'Détection partagée — aucun appel supplémentaire',
    Products: 'Produits',
    Evidence: 'Disponibilité',
    Probabilities: 'Probabilités',
    ProbabilityMeaning:
      'P(vrac) est une probabilité de classe. Les métriques mesurent des accords et désaccords, sans vérité terrain validée.',
    ModelChanged: 'Le modèle ou ses paramètres ont changé. Ce run est bloqué ; créez un nouveau run pour continuer.',
    Restaurant: 'Restaurant',
    Name: 'Nom du run (facultatif)',
    StartDate: 'Date de début',
    EndDate: 'Date de fin',
    Limit: 'Nombre maximal d’images',
    Mode: 'Mode',
    StoredMode: 'Sauvegardé contre candidate',
    PipelineMode: 'Pipeline A contre pipeline B',
    FullPipeline:
      'Chaque image exécute la détection et la classification vrac. Les vues changent uniquement l’affichage. Conservation : 30 jours.',
    Create: 'Créer et lancer',
    Run: 'Run',
    Stop: 'Arrêter la file',
    Expired: 'Ce run a expiré.',
    Progress: '{{completed}} / {{total}} images terminées · {{failed}} en échec · {{pending}} en attente',
    AgreementCounts:
      '{{comparable}} paires comparables · {{disagreements}} désaccords · {{unavailable}} non disponibles ou non comparables',
    MeanDelta: 'Écart moyen de P(vrac)',
    Processing: 'Durée moyenne',
    Resume: 'Reprendre',
    Retry: 'Réessayer cette image',
    Delete: 'Supprimer',
    DeleteConfirm: 'Supprimer ce run et ses résultats expérimentaux ?',
    Cancel: 'Annuler',
    Difference: 'Écarts',
    Status: 'État',
    Sort: 'Tri',
    IoU: 'Seuil IoU du filtre',
    Image: 'Image',
    NoImages: 'Aucune image pour ces filtres.',
    all: 'Tous',
    different: 'Toute différence de détection',
    more: 'Plus de bbox candidates',
    fewer: 'Moins de bbox candidates',
    count: 'Nombre différent',
    low_iou: 'IoU faible',
    classification_disagreement: 'Désaccord de classification',
    classification_unavailable: 'Classification indisponible',
    pending: 'En attente',
    processing: 'En cours',
    completed: 'Terminé',
    failed: 'En erreur',
    chronological: 'Chronologique',
    count_delta: 'Écart de nombre',
    min_iou: 'IoU minimal',
    available: 'Disponible',
    missing: 'Absent',
    stale: 'Obsolète',
    not_applicable: 'Non applicable',
    not_comparable: 'Non comparable',
    comparable: 'Comparable',
    stage_detection: 'Détection',
    stage_vrac: 'Classification vrac',
    stage_total: 'Total',
  },
  ProductCatalog: {
    Title: 'Catalogue de produits',
    Categories: {
      indus_food: 'Industriels / Yaourts',
      drink: 'Boissons',
      fruit: 'Fruits',
      snack: 'Snacks',
    },
    Search: 'Rechercher un nom, une marque ou un ID',
    SearchMinimum: 'Saisissez au moins 3 caractères ou un ID produit.',
    SearchTooLong: 'La recherche ne doit pas dépasser 255 caractères.',
    Brand: 'Marque',
    HasAnnotatedImages: 'Avec des images annotées',
    All: 'Tous',
    Yes: 'Oui',
    No: 'Non',
    NoBrand: 'Sans marque',
    AnnotatedImages_one: '{{count}} image annotée',
    AnnotatedImages_other: '{{count}} images annotées',
    Restaurants: 'Restaurants utilisant ce produit',
    RestaurantsTitle: 'Restaurants utilisant {{name}}',
    RestaurantsScope: 'Seuls les restaurants actifs associés à votre compte sont affichés.',
    NoRestaurants: 'Aucun restaurant actif associé n’utilise ce produit.',
    RestaurantsError: 'Impossible de charger les restaurants.',
    BrandsError: 'Impossible de charger les marques.',
    LoadError: 'Impossible de charger les produits.',
    NoProducts: 'Aucun produit ne correspond à ces filtres.',
    ProductCount_one: '{{count}} produit',
    ProductCount_other: '{{count}} produits',
    RestaurantSearch: 'Rechercher un restaurant ou un ID',
    NoRestaurantMatches: 'Aucun restaurant actif associé ne correspond à votre recherche.',
    LoadingRestaurants: 'Chargement des restaurants…',
    LoadMoreRestaurants: 'Afficher plus de restaurants',
    SortBy: 'Trier par',
    SortOptions: {
      default: 'Par défaut',
      name_asc: 'Nom : A–Z',
      name_desc: 'Nom : Z–A',
      id_asc: 'ID : croissant',
      id_desc: 'ID : décroissant',
      annotated_images_desc: 'Images annotées : décroissant',
      annotated_images_asc: 'Images annotées : croissant',
    },
    ItemsPerPage: 'Produits par page',
    Retry: 'Réessayer',
    Close: 'Fermer',
    Edit: 'Modifier',
    Actions: 'Actions',
    NoImage: 'Aucune image pour ce produit.',
    ImageError: 'Impossible de charger l’image.',
  },
  'Open in TrayHealth': 'Ouvrir dans TrayHealth',
  HealthAnnotationsPairViewer: {
    Settings: 'Paramètres',
    Show_Masks: 'Afficher les masques',
    Show_Labels: 'Afficher les étiquettes',
    Waiting_Initial_Photo: 'En attente de la photo initiale',
    Waiting_Completion_Photo: 'En attente de la photo finale',
    No_Image: 'Aucune image',
    Meal: 'Repas :',
    Client: 'Client :',
    Time: 'Heure :',
    Mask_Opacity: 'Opacité du masque',
    Pair_View: 'Vue par paire',
    Single_View: 'Vue unique',
    Close_Settings: 'Fermer les paramètres',
    Visibility_Settings: 'Paramètres de visibilité',
    Incomplete_Pair: 'Paire incomplète',
    Loading_Image: "Chargement de l'image...",
  },
  Navbar: {
    taxonomy: 'Ingrédients',
    product_catalog: 'Catalogue de produits',
    catalog_industrials: 'Industriels / Yaourts',
    catalog_drinks: 'Boissons',
    catalog_fruits: 'Fruits',
    catalog_snacks: 'Snacks',

    selfcheckout_subheader: 'Encaissement',
    dashboard: 'Tableau de bord',
    restaurant_products: 'Produits',
    menus: 'Menus',
    reports: 'Rapports',
    product_tools: 'Outils Produits',
    api_sandbox: 'API Sandbox',
    health_subheader: 'Santé',
    tools_subheader: 'Outils',
    correction: 'Corriger',
    merge: 'Fusionner',
    edit: 'Modifier',
    create: 'Créer',
    annotations: 'Annotations',
    workspace: 'Espace d’annotation',
    annotation_batches: 'Batches d’annotation',
    legacy_annotations: 'Annotations (ancien outil)',
    evaluation: 'Évaluation',
    pipeline_comparisons: 'Comparaisons de pipelines',
    ingredients_check: 'Vérification des ingrédients',
    ingredients_crop: 'Recadrage des ingrédients',
    admin_subheader: 'Administration',
    users: 'Utilisateurs',
    list: 'Liste',
    restaurants: 'Restaurants',
    itentification_token: 'Identification (Token)',
    visualization: 'Visualisation',
    reporting: 'Reporting',
    summary_csi: 'Résumé CSI',
    api_documentation: 'Documentation API',
    clients: 'Clients',
    'menus management': 'Gestion des menus',
    ciqual: 'Ciqual',
    'dish profiles': 'Profils de plats',
    ingredients_mapping: 'Correspondance ingrédients',
  },
  IngredientProductMappings: {
    Page_Title: 'Correspondances ingrédients',
    Heading: 'Correspondances ingrédients',
    Actions: {
      Create: 'Ajouter une correspondance',
    },
    Table: {
      Ingredient: 'Ingrédient',
      Product: 'Produit',
      Scope: 'Portée',
      Restaurant: 'Restaurant',
      Restaurant_Product: 'Produit restaurant',
    },
    Badges: {
      Fallback: 'Fallback',
      Additive: 'Additif',
    },
    Scope: {
      all: 'Toutes les portées',
      global: 'Globale',
      restaurant: 'Surcharge restaurant',
    },
    Toolbar: {
      Search_Placeholder: 'Rechercher un ingrédient, produit ou produit restaurant...',
      Scope_Label: 'Portée',
      Restaurant_Context: 'Contexte de surcharge restaurant : {{restaurant}}',
      Restaurant_Missing: 'Sélectionnez un restaurant pour afficher et gérer les surcharges restaurant.',
      No_Restaurant: 'Aucun restaurant sélectionné',
    },
    Dialog: {
      Create_Title: 'Créer une correspondance ingrédient',
      Edit_Title: 'Modifier la correspondance ingrédient',
      Create_Action: 'Créer la correspondance',
      Save_Action: 'Enregistrer',
      Scope_Label: 'Portée de la correspondance',
      Ingredient_Label: 'Ingrédient',
      Product_Label: 'Produit canonique',
      Restaurant_Product_Label: 'Produit restaurant',
      Product_Search_Hint: 'Recherchez un produit par nom ou par ID',
      Product_Search_Minimum: 'Tapez au moins {{count}} caractères ou saisissez un ID de produit',
      Product_Search_Error: 'Impossible de rechercher les produits',
      No_Products: 'Aucun produit trouvé',
      Restaurant_Context: 'Cible de surcharge restaurant : {{restaurant}}',
      Derived_Product: 'Le produit canonique sera dérivé de {{product}}.',
      Show_Conflict: 'Afficher la correspondance existante',
      Fallback_Label: 'Produit de fallback',
      Fallback_Helper: 'Utilisé lorsque le produit parent du classifier n’est compatible avec aucune cible.',
      Additive_Label: 'Ingrédient additif',
      Additive_Helper: 'Ce choix est global à l’ingrédient et ajoute ses détections aux parents incompatibles.',
    },
    Delete: {
      Title: 'Supprimer la correspondance ingrédient',
      Description: 'Supprimer la correspondance entre {{ingredient}} et {{product}} ?',
      Confirm: 'Supprimer la correspondance',
      Fallback_Required: 'Désignez d’abord un autre produit de fallback avant de supprimer cette correspondance.',
    },
    Snackbar: {
      Create_Success: 'Correspondance ingrédient créée avec succès',
      Update_Success: 'Correspondance ingrédient mise à jour avec succès',
      Delete_Success: 'Correspondance ingrédient supprimée avec succès',
      Save_Error: 'Erreur lors de l’enregistrement de la correspondance ingrédient',
      Conflict_Error: 'La configuration de la correspondance est incompatible avec la portée sélectionnée.',
      Delete_Error: 'Erreur lors de la suppression de la correspondance ingrédient',
      Load_Error: 'Erreur lors du chargement des correspondances ingrédient',
    },
    Rows_Per_Page: 'Correspondances par page',
    Dense: 'Dense',
  },
  AnnotationWorkspace: {
    AnnotationBatches: 'Batches d’annotation',
    BatchStatus: 'Statut',
    BatchStatuses: 'Statuts',
    BatchStatusTodo: 'À faire',
    BatchStatusInProgress: 'En cours',
    BatchStatusToReview: 'À vérifier',
    BatchStatusReviewed: 'Vérifié',
    BatchStatusArchived: 'Archivé',
    AllBatchStatuses: 'Tous les statuts',
    BatchSort: 'Trier par',
    BatchSortStatus: 'Statut',
    BatchSortNewest: 'Plus récents',
    CreateBatch: 'Créer un batch',
    EditBatch: 'Modifier le batch',
    DeleteBatch: 'Supprimer le batch',
    BatchName: 'Nom du batch',
    BatchAssignees: 'Annotateurs affectés',
    Restaurants: 'Restaurants',
    BatchRestaurantsHelp:
      'Les restaurants définissent le périmètre du batch et ne peuvent plus être modifiés après sa création.',
    BatchAssignmentHelp: 'L’affectation organise le travail. Les droits d’accès restent ceux des restaurants.',
    UnableToLoadBatchUsers:
      'Impossible de charger les utilisateurs. Vous pouvez enregistrer le batch sans modifier les affectations.',
    UnableToSaveBatch: 'Impossible d’enregistrer le batch.',
    UnableToLoadBatch: 'Impossible de charger ce batch. Vérifiez vos droits d’accès aux restaurants.',
    UnableToLoadBatches: 'Impossible de charger les batches.',
    AllBatches: 'Tous les batches',
    MyBatches: 'Mes batches',
    NoBatches: 'Aucun batch à afficher.',
    BatchPlateauCount_one: '{{count}} plateau',
    BatchPlateauCount_other: '{{count}} plateaux',
    UnassignedBatch: 'Non affecté',
    DeleteBatchConfirmation: 'Supprimer « {{name}} » ? Les images et les annotations seront conservées.',
    BatchSaved: 'Batch enregistré.',
    AddBatchImages: 'Ajouter des plateaux',
    AnnotationBatchMode: 'Batch d’annotation',
    OpenBatchOptions: 'Options des batches',
    EditBatchMembership: 'Modifier les plateaux du batch',
    BatchAddingMode: 'Ajouter des plateaux au batch',
    BatchMembersHelp: 'Les plateaux cochés appartiennent à ce batch. Décochez un plateau pour le retirer.',
    BatchCandidateHelp: 'Cochez un plateau pour l’ajouter au batch. Décochez-le pour le retirer.',
    BatchReadOnlyHelp: 'Les filtres restreignent l’affichage sans modifier les plateaux enregistrés dans ce batch.',
    BatchImmediateChanges: 'Enregistrement automatique',
    BatchAllFilteredHelp: 'L’ajout inclut toutes les pages et respecte les filtres et la plage actuels.',
    AddAllFilteredToBatch: 'Ajouter tous les résultats du filtre ({{count}})',
    ViewBatch: 'Voir les plateaux du batch',
    ManageAnnotationBatches: 'Gérer les batches',
    PrepareAnnotationBatch: 'Créer ou remplir un batch',
    BatchSelectionHelp: 'Cochez les plateaux à regrouper, ou utilisez tous les résultats du filtre.',
    CreateBatchFromSelection: 'Créer avec la sélection',
    AddSelectionToBatch: 'Ajouter la sélection à un batch',
    CreateBatchFromFilter: 'Créer avec tous les résultats',
    AddFilterToBatch: 'Ajouter tous les résultats à un batch',
    UnableToLoadBatchMembership:
      'Impossible de vérifier les plateaux présents dans le batch. Réessayez avant de modifier les cases.',
    IncludeBatchPlateau: 'Inclure le plateau {{id}} dans le batch',
    CopyBatchLink: 'Copier le lien du batch',
    BatchLinkCopied: 'Lien du batch copié.',
    UnableToCopyBatchLink: 'Impossible de copier le lien du batch. Veuillez réessayer.',
    OpenBatch: 'Ouvrir le batch',
    ExitBatch: 'Quitter le batch',
    InvalidBatchLink: 'Le lien du batch est invalide.',
    EndBatchSelection: 'Terminer la sélection',
    SelectBatchImages: 'Sélectionner des plateaux',
    BatchSelectedCount_one: '{{count}} plateau sélectionné',
    BatchSelectedCount_other: '{{count}} plateaux sélectionnés',
    ClearBatchSelection: 'Effacer la sélection',
    BatchSource: 'Plateaux à ajouter',
    BatchFilteredSource: 'Résultats filtrés ({{count}})',
    AddToBatch: 'Ajouter à un batch',
    RemoveFromBatch: 'Retirer du batch',
    ChooseTargetBatch: 'Choisir le batch destinataire',
    SelectBatchPlateau: 'Sélectionner le plateau {{id}}',
    ResultRange: 'Plage de résultats',
    RangeStart: 'De la position',
    RangeEnd: 'À la position',
    ResultRangeHelp:
      'Positions inclusives à partir de 1. Chaque résultat est un plateau avec ses caméras. La plage suit les filtres et le tri actuels.',
    InvalidResultRange: 'Saisissez deux positions entières à partir de 1, avec une fin supérieure ou égale au début.',
    ClearResultRange: 'Effacer la plage',
    CopyWorkspaceLink: 'Copier le lien',
    WorkspaceLinkCopied: 'Lien du Workspace copié.',
    UnableToCopyWorkspaceLink:
      'Impossible de copier le lien. Vous pouvez copier l’URL de la page dans la barre d’adresse.',
    Ingredient: 'Ingrédient',
    AnnotationChanges: 'Modifications des annotations',
    ModifiedBy: 'Modifié par',
    ModifiedBetween: 'Modifié entre',
    ClearModificationDates: 'Effacer les dates de modification',
    UnableToLoadHistoryUsers: 'Impossible de charger les utilisateurs de l’historique des annotations.',

    DisplayOptions: 'Options d’affichage',
    ShowIngredientsInBoxList: 'Afficher les ingrédients dans la liste des boîtes',
    CollapseInspector: 'Réduire l’inspecteur',
    ExpandInspector: 'Ouvrir l’inspecteur',
    MultipleRestaurants: 'Plusieurs restaurants',
    SelectRestaurant: 'Sélectionnez un restaurant',
    DetectionScore: 'Score de détection',
    IngredientDetectionScore: 'Score de détection des ingrédients',
    MinimumScore: 'Min',
    MaximumScore: 'Max',
    ApplyScores: 'Appliquer les scores',
    InvalidScore: 'Saisissez un pourcentage de 0 à 100',
    InvalidScoreRange: 'Le maximum doit être supérieur ou égal au minimum',
    UnableToLoadFilterOptions: 'Impossible de charger les options des filtres',
    PageTitle: 'Espace d’annotation',
    LegacyPageTitle: 'Annotations : Images (ancien outil)',
    PageHeading: 'Espace d’annotation',
    Dashboard: 'Tableau de bord',
    Annotations: 'Annotations',
    AnnotationWorkspace: 'Espace d’annotation',
    Images: 'Images',
    Filters: 'Filtres',
    Close: 'Fermer',
    Refresh: 'Rafraîchir',
    AutoRefresh: 'Rafraîchissement auto',
    AutoRefreshOff: 'Désactivé',
    AutoRefreshSeconds: '{{count}} s',
    AutoRefreshMinutes: '{{count}} min',
    UnableToRefreshAnnotations: 'Impossible de rafraîchir les annotations',
    Save: 'Enregistrer',
    ResultRail: 'Rail de résultats',
    NewestFirst: 'Plus récentes en premier',
    OldestFirst: 'Plus anciennes en premier',
    ChangeImageOrder: "Changer l'ordre des images",
    Workspace: 'Espace de travail',
    Inspector: 'Inspecteur',
    Context: 'Contexte',
    Details: 'Détails',
    Ingredients: 'Ingrédients',
    History: 'Historique',
    Tickets: 'Tickets',
    Restaurant: 'Restaurant',
    FromDate: 'Date de début',
    ToDate: 'Date de fin',
    DateRange: 'Plage de dates',
    SelectStartDate: 'Sélectionnez une date de début',
    SelectEndDate: 'Sélectionnez une date de fin',
    Apply: 'Appliquer',
    Cancel: 'Annuler',
    Product: 'Produit',
    ObjectClass: "Type d'objet",
    ImageValidation: "Validation de l'image",
    Enrollment: 'Enrôlement',
    TicketPresence: 'Présence de ticket',
    AnnotationPresence: 'Présence de boîtes',
    IngredientPresence: "Annotations d'ingrédients",
    Camera: 'Caméra',
    UseDailyProductsOnly: 'Utiliser uniquement les produits du jour',
    AllProducts: 'Tous les produits',
    Reset: 'Réinitialiser',
    All: 'Tous',
    Yes: 'Oui',
    No: 'Non',
    ValidatedOnly: 'Validés uniquement',
    NeedsValidation: 'À valider',
    EnrolledOnly: 'Enrôlés uniquement',
    NotEnrolled: 'Non enrôlés',
    HasTicketOnly: 'Avec tickets',
    WithoutTicket: 'Sans ticket',
    HasAnnotationsOnly: 'Avec boîtes',
    WithoutAnnotations: 'Sans boîte',
    HasIngredientsOnly: "Avec annotations d'ingrédients",
    WithoutIngredients: "Sans annotation d'ingrédient",
    ImageValidated: 'Image validée',
    Enrolled: 'Enrôlé',
    Ticket: 'Ticket',
    TraysCount: '{{count}} plateaux',
    TrayNumber: 'Plateau {{id}}',
    ValidatedBboxCount: '{{validated}}/{{total}} validées',
    UnknownTime: 'Heure inconnue',
    UnableToLoadSummaries: "Impossible de charger les résumés d'images.",
    NoTraysMatchFilters: 'Aucun plateau ne correspond aux filtres actuels.',
    CopyLink: 'Copier le lien',
    DownloadImage: "Télécharger l'image",
    EditTools: 'Édition',
    SelectBox: 'Sélectionner',
    DrawBox: 'Tracer une boîte',
    ViewOptions: 'Affichage',
    RunAI: 'Lancer l’IA',
    SearchExistingProducts: 'Rechercher un produit',
    ExistingProductProposals: 'Produits correspondants dans la base',
    ProductSearchArea: 'Zone de recherche',
    ProductSearchAutomatic: 'Image entière (détection automatique)',
    ProductSearchBox: 'Bbox {{id}}',
    ProductSearchSelectedBoxHint: 'La recherche utilise directement cette bbox pour le crop, sans détection.',
    ProductSearchAutomaticHint: 'Sélectionnez une bbox pour rechercher uniquement le produit qu’elle contient.',
    ProposalImageNumber: 'Image {{number}}',
    NoImageToSearch: 'Aucune image disponible pour la recherche.',
    SearchingExistingProducts: 'Recherche de produits en cours',
    UnableToSearchProducts: 'Impossible de rechercher les produits. Veuillez réessayer.',
    NoExistingProductsFound: 'Aucun produit correspondant trouvé pour cette image.',
    ProposalProductNumber: 'Produit {{id}}',
    ProposalMatchScore: 'Correspondance : {{score}} %',
    CloseProductSearch: 'Fermer',
    SearchProductsAgain: 'Relancer la recherche',
    MoreActions: 'Plus d’actions',
    MoreBboxActions: 'Autres actions sur les boîtes',
    AllChangesSaved: 'Modifications enregistrées',
    SavingChanges: 'Enregistrement…',
    AddBox: 'Ajouter une boîte',
    BatchMenu: 'Batch',
    BatchActions: 'Actions du batch',
    ActiveBatch: 'Batch actif',
    BatchFilteredResults_one: '{{count}} image filtrée',
    BatchFilteredResults_other: '{{count}} images filtrées',
    ValidateFilteredBatch: 'Valider le batch',
    ValidateFilteredBatchHint: 'Valide les images filtrées et toutes leurs boxes.',
    ValidateFilteredBatchConfirm:
      'Valider toutes les boxes et images des {{count}} résultats filtrés du batch ? Cette action est enregistrée immédiatement.',
    ValidateFilteredBatchProgress: 'Validation : {{completed}} / {{total}} images',
    ValidateFilteredBatchSuccess: '{{count}} images validées.',
    ValidateFilteredBatchError:
      'Validation interrompue après {{count}} images. Les modifications déjà enregistrées sont conservées.',
    ValidateAll: 'Tout valider',
    UnvalidateAll: 'Tout invalider',
    Analyze: 'Analyser',
    Restore: 'Restaurer',
    UnsavedChanges: 'Modifications non enregistrées',
    EnrolledImage: 'Image enrôlée',
    PickTrayHint: "Sélectionnez un plateau dans le rail de résultats pour ouvrir l'éditeur.",
    CapturedAt: 'Capturé à',
    Revision: 'Révision',
    ActiveCamera: 'Caméra active',
    ImageMedia: 'Média image',
    TrayMeal: 'Repas plateau',
    SelectProductBoxHint: 'Sélectionnez une boîte produit sur le canevas pour inspecter et modifier ses ingrédients.',
    IngredientEditorInWorkspace: "L'édition des ingrédients est ouverte dans l'espace de travail principal.",
    SelectedProductBox: 'Boîte produit sélectionnée',
    Selected: 'Sélectionné',
    KeyboardNavigationHint: '← / → image précédente et suivante',
    Shortcuts: 'Raccourcis',
    KeyboardShortcuts: 'Raccourcis clavier',
    ProductModeShortcuts: "Mode d'annotation produit",
    IngredientModeShortcuts: "Mode d'annotation ingrédient",
    PreviousImage: 'Image précédente',
    NextImage: 'Image suivante',
    SaveAnnotations: 'Enregistrer les annotations',
    CancelChanges: 'Annuler les modifications',
    ToggleAddBox: "Activer l'ajout de boîte produit",
    OpenClassQuickMenu: 'Choisir la classe de la boîte au curseur',
    OpenProductQuickMenu: 'Choisir le produit de la boîte au curseur',
    QuickMenuTitle: 'Modifier la boîte sélectionnée',
    QuickMenuValidate: 'Valider la boîte',
    QuickMenuInvalidate: 'Invalider la boîte',
    QuickMenuDelete: 'Supprimer la boîte',
    AutoOpenBoxQuickMenu: 'Ouvrir le menu après le dessin d’une boîte',
    QuickMenuClass: 'Classe',
    QuickMenuProduct: 'Produit',
    QuickMenuSearch: 'Rechercher…',
    QuickMenuRecentChoices: 'Choix récents',
    QuickMenuLoading: 'Chargement des produits…',
    QuickMenuNoClasses: 'Aucune classe disponible',
    QuickMenuKeyboardHint: '↑ ↓ naviguer · Entrée sélectionner · Échap fermer',
    ToggleImageValidation: "Basculer la validation de l'image",
    ValidateAllBoxes: 'Basculer la validation de la boîte produit sélectionnée (toutes si aucune sélection)',
    DeleteSelectedBox: 'Supprimer la boîte produit sélectionnée',
    OpenIngredientMode: 'Ouvrir le mode ingrédient',
    ToggleIngredientBox: "Activer l'ajout de boîte ingrédient",
    ValidateIngredientBoxes: 'Basculer la validation de la boîte ingrédient sélectionnée (toutes si aucune sélection)',
    DeleteSelectedIngredientBox: 'Supprimer la boîte ingrédient sélectionnée',
    BackToImage: 'Retour à l’image',
    IngredientCrops: 'Recadrages produits',
    NoProductCrops: 'Aucun recadrage produit sur cette image',
    CropNavigation: 'Navigation entre les recadrages',
    CropValidated: 'Recadrage validé',
    UnsavedIngredientChangesTitle: 'Enregistrer les modifications des ingrédients ?',
    UnsavedIngredientChangesDescription:
      'Vous avez modifié les ingrédients pendant cette session. Enregistrez-les, annulez uniquement ces modifications ou continuez à éditer.',
    SaveAndReturn: 'Enregistrer et revenir',
    DiscardAndReturn: 'Annuler et revenir',
    KeepEditing: 'Continuer à éditer',
    SaveProductBeforeAnalysis: 'Enregistrez cette boîte produit avant d’analyser ses ingrédients.',
    ExitIngredientMode: 'Retourner à l’image',
    JumpToImage: 'Aller à une image',
    ImagePosition: '{{current}} / {{total}}',
    ViewingPosition: 'Affichage {{current}} / {{total}}',
    NearbyImages: '{{count}} à proximité',
    ProductBoxNumber: 'Boîte produit #{{id}}',
    UnableToLoadTickets: 'Impossible de charger les tickets.',
    ClientResponse: 'Réponse de l’IA',
    TicketItems: 'Articles du ticket',
    ResponseHistory: 'Historique des réponses',
    ProductsReturned: 'Produits renvoyés',
    NoProductsReturned: 'Aucun produit renvoyé',
    UnknownReturnedProduct: 'Produit inconnu',
    RawJson: 'JSON brut',
    NoClientResponses: 'Aucune réponse de l’IA enregistrée pour ce plateau.',
    UnableToLoadClientResponses: 'Impossible de charger les réponses de l’IA enregistrées.',
    NoTicketRows: "Aucune ligne de ticket CSI n'a été renvoyée pour ce plateau.",
    UnknownTicketRow: 'Ligne de ticket inconnue',
    OpenProduct: 'Ouvrir le produit #{{id}}',
    NotLinkedToProduct: 'Non lié à un produit.',
    HistoryChanges_one: '{{count}} modification',
    HistoryChanges_other: '{{count}} modifications',
    HistoryTechnicalDetails: 'Détails techniques',
    HistoryEntities: {
      product_box: 'Zone produit',
      product_assignment: 'Attribution produit',
      ingredient_box: 'Zone ingrédient',
    },
    HistoryChangeTypes: { created: 'Créé', updated: 'Modifié', deleted: 'Supprimé' },
    UnknownTimestamp: 'Horodatage inconnu',
    UserActor: 'Utilisateur #{{id}}',
    SystemActor: 'Système ou acteur inconnu',
    Retry: 'Réessayer',
    UnableToLoadHistory: "Impossible de charger l'historique.",
    NoHistoryRows:
      "Aucune ligne d'historique pour cette portée. Les événements de création ne sont pas stockés dans le flux backend actuel.",
    PageOf: 'Page {{page}} sur {{pages}}',
    AnalysisStillRunning: '{{label}} est toujours en cours. Rafraîchissez manuellement pour vérifier le résultat.',
    AnnotationsSaved: 'Annotations enregistrées',
    SavingImageInBackground: 'Enregistrement de l’image {{id}} ({{camera}}) en arrière-plan…',
    BackgroundSaveFailed:
      'L’image {{id}} ({{camera}}) n’a pas pu être enregistrée. Vos modifications sont conservées ; rouvrez l’image pour les vérifier et réessayer.',
    ReopenUnsavedImage: 'Ouvrir l’image {{id}} ({{camera}})',
    StaleRevisionSaveRejected: 'Enregistrement refusé car la révision est obsolète. Rafraîchissez puis réessayez.',
    UnableToSaveAnnotations: "Impossible d'enregistrer les annotations.",
    ImageAnalysisRequested: "Analyse d'image demandée",
    ImageAnalysisLabel: "Analyse d'image",
    UnableToStartImageAnalysis: "Impossible de démarrer l'analyse d'image.",
    IngredientAnalysisRequested: 'Analyse des ingrédients demandée',
    IngredientAnalysisLabel: 'Analyse des ingrédients',
    UnableToStartIngredientAnalysis: "Impossible de démarrer l'analyse des ingrédients.",
    ConfirmRestore: "Restaurer l'image originale pour la caméra active ?",
    OriginalImageRestored: 'Image originale restaurée',
    UnableToRestoreOriginalImage: "Impossible de restaurer l'image originale.",
    StableLinkCopied: 'Lien stable copié',
    ClickToCopyId: "Cliquer pour copier l'identifiant",
    CopyId: "Copier l'identifiant {{id}}",
    IdCopied: 'Identifiant {{id}} copié',
    UnableToCopyId: "Impossible de copier l'identifiant",
    UnableToCopyLink: 'Impossible de copier le lien.',
    PollingInfo: '{{label}} est en cours. La requête de détail interroge une nouvelle révision.',
    ActiveFilters: 'Filtres actifs',
    NoExtraFilters: 'Aucun filtre supplémentaire appliqué.',
    MobileTabs: {
      results: 'Résultats',
      workspace: 'Travail',
      inspector: 'Inspecteur',
    },
  },
  BulkProductEdit: {
    Title: 'Modifier {{count}} produit(s) sélectionné(s)',
    Field: 'Champ',
    Value: 'Valeur',
    Apply: 'Appliquer',
  },
  RestaurantProductList: {
    Restaurant_Product_List_Title: 'Produits du restaurant',
    Restaurant_Product_List_Heading: 'Produits du restaurant',
    New_Product: 'Ajouter un produit',
    Products_Deleted_Successfully: 'Produits supprimés avec succès !',
    Product_Delete_Error: 'Erreur lors de la suppression du produit',
    Product_Added_To: 'Produits ajoutés au menu du ',
    Product_Name: 'Nom du produit',
    Cash_Sys_Code: "Code d'encaissement",
    Is_Recurrent: 'Récurrent',
    Is_Industrial: 'Industriel',
    Is_Container: 'Contenant',
    Is_Returned: 'Retourné',
    To_Count: 'À compter',
    Object_Class: 'Type',
    TableToolbar: {
      Search_Product: 'Rechercher un produit...',
    },
    Choose_Date_Menu: 'Choisir une date pour le menu',
    Add_To_Menu: 'Ajouter au menu',
    Delete_Products: 'Supprimer les produits',
    Dense: 'Dense',
    Rows_Per_Page: 'Produits par page',
    There_Is_Only: "Attention, il n'y a que",
    Excluded_From_Analysis: "Ce produit est exclu de l'analyse",
    Image: 'image',
    Must_Provide: 'pour ce produit. Vous devez fournir au moins 5 images et contacter Trayvisor.',
    Set_Is_Recurrent: 'Set_Is_Recurrent',
    Cancel: 'Annuler',
    True: 'Vrai',
    False: 'Faux',
    Product: 'Produit',
    Original_Product: 'Produit original',
    Linked_Ingredients: 'Ingrédients liés',
    Linked_Only: 'Liés uniquement',
    Unlinked_Only: 'Non liés uniquement',
    Is_Recurrent_Change: 'Le status récurrents des produits a été modifié !',
    Bulk_Edit: 'Modification groupée',
    Bulk_Update_Success: 'Produits sélectionnés mis à jour avec succès !',
    Bulk_Update_Error: 'Erreur lors de la mise à jour des produits sélectionnés',
  },
  RestaurantProductCreate: {
    Restaurant_Product_Create_Title: 'Produits : Ajouter un nouveau produit',
    Restaurant_Product_Create_Heading_Add: 'Ajouter un nouveau produit',
    Restaurant_Product_Create_Heading_Edit: 'Modifier un produit',
    NewEditForm: {
      Restaurant_Products: 'Produits',
      New_Product: 'Ajouter un produit',
      Filter_By_Object_Class: "Filtrer par type d'object",
      Product: 'Produit',
      Choose_Product: 'Choisir un produit',
      Image_Example_Product: "Image d'exemple du produit",
      Product_Required: 'Produit requis',
      Product_Name_Required: 'Nom du produit requis',
      CashSysCode_Required: "Code d'encaissement requis",
      Product_Added_Success: 'Produit ajouté à votre restaurant !',
      Product_Update_Success: 'Mise à jour réussie !',
      Set_Up_Product: 'Configurer le produit',
      Product_Name: 'Nom produit',
      CashSysCode: "Code d'encaissement",
      Is_Recurrent: 'Est Récurrent',
      Is_Recurrent_Info: 'Les produits récurrents seront automatiquement ajoutés au menu chaque jour.',
      Is_Returned: 'Retourné',
      Is_Returned_Info: "Les produits non retournés seront exclus des résultats d'analyse",
      Add_Product: 'Ajouter le produit',
      Save_Changes: 'Sauvegarder les changements',
      Use_Daily_Products_only: 'Utiliser uniquement les produits du jour',
      Validated_As_Annotation: 'Validé comme annotation',
      No_Selection: 'Aucune sélection',
      Start_Typing_Products: 'Commencez à taper pour afficher des produits',
      Type_Minimum_Characters: 'Tapez au moins {{count}} caractères',
      No_Products_Found: 'Aucun produit trouvé',
      Linked_Ingredients: 'Ingrédients liés',
      Ingredient_Mapping_Title: 'Correspondance ingrédient',
      Ingredient_Mapping_Scope: 'Portée de la correspondance',
      Ingredient_Mapping_Scope_Restaurant: 'Surcharge restaurant',
      Ingredient_Mapping_Scope_Global: 'Globale',
      Ingredient_Mapping_Helper_Text: 'Sélectionnez les ingrédients à associer à cette portée.',
      Ingredient_Mapping_Read_Only:
        'Vous pouvez consulter les correspondances ingrédient, mais vous n’avez pas l’autorisation de les modifier.',
      Inherited_Global_Ingredients: 'Ingrédients globaux hérités',
      Retry_Ingredient_Mapping: 'Réessayer la synchronisation',
      Ingredient_Mapping_Save_Success: 'Les correspondances ingrédient ont été enregistrées avec succès.',
      Ingredient_Mapping_Save_Error: 'Erreur lors de l’enregistrement des correspondances ingrédient.',
      Ingredient_Mapping_Save_Error_With_Conflicts:
        'Certains ingrédients sont déjà associés dans cette portée : {{conflicts}}.',
      Ingredient_Mapping_Partial_Error:
        'Le produit restaurant a été enregistré, mais les correspondances ingrédient n’ont pas pu être mises à jour.',
      Ingredient_Mapping_Partial_Error_With_Conflicts:
        'Le produit restaurant a été enregistré, mais ces correspondances ingrédient sont en conflit : {{conflicts}}.',
      No_Ingredients_Found: 'Aucun ingrédient trouvé',
      Select_Product_First: 'Sélectionnez d’abord un produit',
    },
  },
  IngredientAnnotation: {
    Ingredients: 'Ingrédients',
    No_Selection: 'Aucune sélection',
    All: 'Tous',
    Validate_All_Ingredient_Boxes: "Valider toutes les boîtes d'ingrédients",
    Unvalidate_All_Ingredient_Boxes: "Dévalider toutes les boîtes d'ingrédients",
    Add_Ingredient_Box: "Ajouter une boîte d'ingrédient",
    Save_Ingredient_Changes: "Sauvegarder les modifications d'ingrédients",
    Analyze_Ingredients: 'Analyser les ingrédients',
    Validated_As_Ingredient_Annotation: "Validé comme annotation d'ingrédient",
    Not_Validated_As_Ingredient_Annotation: "Non validé comme annotation d'ingrédient",
    Ingredient_Box_ID: "ID de la boîte d'ingrédient",
    Choose_Ingredient: 'Choisir un ingrédient',
    Ingredient: 'Ingrédient',
    Create_Ingredient: 'Créer un ingrédient',
    Picker_Search: 'Rechercher un ingrédient',
    Picker_Search_Placeholder: 'Nom ou code…',
    Picker_Results: 'Résultats',
    Picker_Recent: 'Récents',
    Picker_Categories: 'Catégories',
    Picker_All_Categories: 'Toutes les catégories',
    Picker_Browse: 'Parcourir les catégories',
    Picker_Quick_Search: 'Recherche rapide',
    Picker_Back: 'Catégorie précédente',
    Picker_Open_Category: 'Parcourir {{name}}',
    Picker_Select_Category: 'Choisir « {{name}} »',
    Picker_No_Results: 'Aucun ingrédient trouvé',
    Picker_Clear: 'Retirer l’ingrédient',
    Close: 'Fermer',
    Ingredient_Name: "Nom de l'ingrédient",
    Ingredient_Name_Required: "Le nom de l'ingrédient est requis",
    Ingredient_Description: 'Description',
    Validated_As_Annotation: 'Validé comme annotation',
    Ingredient_Annotations_Crop_Title: "Annotations d'ingrédients : Crop",
    Ingredient_Annotations_Check_Title: "Annotations d'ingrédients : Check",
    Ingredient_Annotations_Crop: 'Check',
    Ingredient_Annotations_Check: 'Crop',
    Filters: 'Filtres',
    Paging: 'Pagination',
    Restaurant: 'Restaurant',
    Dates: 'Dates',
    From_Date: 'Date de début',
    To_Date: 'Date de fin',
    Enrolled: 'Enrôlé',
    Offset: 'Décalage',
    Limit: 'Limite',
    Apply_Filter: 'Appliquer le filtre',
    Clear_Filter: 'Réinitialiser',
    Sort_By: 'Trier par',
    Sort_Newest: 'Plus récents',
    Sort_Oldest: 'Plus anciens',
    Sort_Ingredient: 'Ingrédient',
    End_Of_List: 'Vous avez tout vu.',
    Scroll_To_Top: 'Retour en haut',
    Save_Product_Box_Error: "Erreur lors de l'enregistrement des modifications de la boîte produit",
    Ingredient_Save_Box_Error: "Erreur lors de l'enregistrement de la boîte d'ingrédient, contactez l'admin !",
    Ingredient_Update_Box_Error: "Erreur lors de la mise à jour de la boîte d'ingrédient, contactez l'admin !",
    Ingredient_Delete_Box_Error: "Erreur lors de la suppression de la boîte d'ingrédient, contactez l'admin !",
    Ingredient_Save_Success: 'Modifications des ingrédients enregistrées avec succès',
    Ingredient_Save_Error: "Erreur lors de l'enregistrement des modifications d'ingrédients",
    Ingredient_Create_Success: 'Ingrédient créé avec succès',
    Ingredient_Create_Error: "Erreur lors de la création de l'ingrédient",
    Ingredients_Analysis_Done: 'Analyse des ingrédients terminée',
    Ingredients_Analysis_Started: 'Analyse des ingrédients démarrée',
  },
  ProductGeneral: {
    Is_Active: 'Actif',
    Product_Title: 'Produits',
    Name: 'Nom du produit',
    Label: 'Libellé du produit',
    Description: 'Description du produit',
    Object_Class: "Type d'objet (détection)",
    Kind: 'Type',
    Family: 'Famille',
    Brand: 'Marque',
    Food_class: 'Classe alimentaire',
    Is_Industrial: 'Industriel',
    Is_Content: 'Contenant',
    To_Count: 'À compter',
    Linked_Ingredients: 'Ingrédients liés',
    Search_Query_Too_Long: 'La recherche doit contenir au maximum {{max}} caractères.',
  },
  ProductList: {
    Product_List_Heading: 'Produits',
    Product: 'Produit',
    List: 'Liste',
    Add_Product: 'Ajouter un produit',
    Merge_Products: 'Fusionner des produits',
    Bulk_Edit: 'Modification groupée',
    Bulk_Update_Success: 'Produits sélectionnés mis à jour avec succès !',
    Bulk_Update_Error: 'Erreur lors de la mise à jour des produits sélectionnés',
    TableRow: {
      Inactive: 'Inactif',
    },
    TableHead: {
      Id: 'ID',
      Product_Name: 'Nom du produit',
    },
    TableToolbar: {
      Status: 'Statut',
      Status_active: 'Actifs',
      Status_inactive: 'Inactifs',
      Status_all: 'Tous',
      Search_Product: 'Rechercher un produit...',
    },
    Dense: 'Dense',
    Rows_Per_Page: 'Produits par page',
  },
  ProductCreate: {
    Is_Active_Info: 'Détermine si ce produit apparaît par défaut dans la liste des produits.',
    Product_Heading_Add: 'Ajouter un nouveau produit',
    Product_Heading_Edit: 'Modifier un produit',
    New_Product: 'Nouveau produit',
    Set_Up_Product: 'Configurer le nouveau produit',
    Product_Name_Required: 'Nom du produit requis',
    Description_Required: 'Description du produit requise',
    Label_Required: 'Label du produit requis',
    Is_Indus_Required: 'Industriel requis',
    Is_Content_Required: 'Contenant requis',
    To_Count_Required: 'À compter requis',
    Kind_Required: 'Type requis',
    Family_Required: 'Famille requise',
    Brand_Required: 'Marque requise',
    Object_Class_Required: 'Object class requis',
    Images_Required: '1 image au moins est requise',
    Product_Added_Success: 'Produit ajouté avec succés !',
    Branch_Added_Success: 'Marque ajouté avec succés !',
    Food_Class_Added_Success: 'Classe alimentaire ajoutée avec succès !',
    Product_Update_Success: 'Mise à jour réussi !',
    Add_Product: 'Ajouter le produit',
    Save_Changes: 'Sauvergarder les changements',
    Add_Brand: 'Ajouter une marque',
    Add_New_Brand: 'Ajouter une nouvelle marque',
    Brand_Name: 'Nom de la marque',
    Add_Food_Class: 'Ajouter une classe alimentaire',
    Add_New_Food_Class: 'Ajouter une nouvelle classe alimentaire',
    Enrolled_By: 'Enrôlé par',
    Is_Industrial_Info: 'Les produits industriels sont ceux packagés.',
    Is_Content_Info: 'Pour la reconnaissance au contenant.',
    To_Count_Info: 'Compter les ingrédients de ce produit',
    Image_Example_Product: "Image d'exemple",
    NutritionCard: {
      Set_Up_Nutrition_Card: 'Configurer les informations  nutritionnelles',
      Calcium: 'Calcium',
      Cho: 'Glucides',
      Diet_fibre: 'Fibre alimentaire',
      Diet_Iron: 'Fer',
      Gross_Weight: 'Poids brut',
      Kcal: 'Kcal',
      Net_Weight: 'Poids net',
      Protein: 'Protéines',
      Sat_Fat: 'Acides gras saturés',
      Sodium: 'Sodium',
      Sugars: 'Sucre',
      Total_Fat: 'Lipides',
    },
  },
  Products: {
    ClassOptions: {
      Class_All: 'Tous',
      Class_Indus_Food: 'Packagé',
      Class_Fruit: 'Fruit',
      Class_Drink: 'Boisson',
      Class_Dessert_Starter: 'Entrée/Dessert',
      Class_Dish: 'Plat',
      Class_Bread: 'Pain',
      Class_Unknown: 'Inconnu',
      Class_Others: 'Autre',
    },
  },
  Menus: {
    Menus_Title: 'Menus',
    Menus_Header: 'Menus',
    Menu_Date: 'Date du menu',
    Add_Products: 'Ajouter des produits au menu',
    Delete_From_Menu: 'Supprimer du menu',
    Product_Removed_From_Menu_Success: 'Produit supprimé du menu',
    Product_Remove_From_Menu_Error: 'Erreur lors de la suppression du produit du menu',
    Display_Menu_History: "Afficher l'historique des menus",
    Last_Menu_Received_at: 'Dernier menu reçu',
    No_Menu_Received_Today: "Aucun menu reçu aujourd'hui",
    Menu_History: 'Historique des menus',
    Menu_History_Close: "Fermer l'historique des menus",
    Menu_History_Received: 'Menus reçus',
    Menu_History_Products_View: 'Produits',
    Menu_History_Search: 'Rechercher par nom ou code produit',
    Menu_History_Product_Count_one: '{{count}} produit',
    Menu_History_Product_Count_other: '{{count}} produits',
    Menu_History_No_Matches: 'Aucun produit ne correspond à la recherche',
    Menu_History_No_Products: 'Cette archive ne contient aucun produit',
    Menu_History_Unnamed_Product: 'Produit sans nom',
    Menu_History_Code: 'Code',
    Menu_History_Catering_Code: 'Code restauration',
    Menu_History_Visual_Id: 'ID visuel',
    Menu_History_Labels_one: '{{count}} libellé',
    Menu_History_Labels_other: '{{count}} libellés',
    Menu_History_Download: 'Télécharger le JSON',
    Menu_History_Local_Time: 'Heure affichée en heure locale (24h)',
    Menu_History_Load_Error: 'Impossible de charger le menu archivé',
    Menu_History_Refresh_Error: "Menu renvoyé, mais l'affichage n'a pas pu être actualisé",
    Menu_Manual_Resend: 'Menu renvoyé manuellement',
    Menu_Resend_Provenance: 'Renvoyé manuellement par {{user}} depuis le menu reçu le {{date}} à {{time}}',
    Menu_Archive_Pending: "Le nouveau menu n'apparaît pas encore dans l'historique",
    Menu_Resend: 'Renvoyer ce menu',
    Menu_Resending: 'Renvoi en cours…',
    Menu_Resend_Success: "Menu renvoyé à l'API",
    Menu_Resend_Error: 'Échec du renvoi du menu',
  },
  Visualization: {
    Dashboard: 'Tableau de bord',
    Visualization: 'Visualisation',
    Enrollment: 'Enrôlement',
    Analysis: 'Analyse',
    No_Enrollment_Found: 'Aucun enrôlement trouvé pour la date sélectionnée',
  },
  DeviceCreate: {
    Serial_Number: 'Numéro de série',
    Name: 'Nom',
    Pitunnel_Device_Id: 'ID Appareil PiTunnel',
    Min_Value_Required: 'Valeur minimale requise',
    Max_Value_Required: 'Valeur maximale dépassée',
    Number_Required: 'Doit être un nombre',
    Integer_Required: 'Doit être un entier',
    Field_Required: '{{field}} est requis',
    Device_Profile_Required: "Profil d'appareil requis",
    Brightness_Target_Required: 'Cible de luminosité requise',
    Focus_Required: 'Mise au point requise',
    LED_PWMIntensity_Required: 'Intensité LED requise',
    LED_PWMChip_Required: 'Puce PWM LED requise',
    LED_PWMChip_Invalid: 'Seules les valeurs de 0 à 3 sont autorisées',
    LED_PWMChannel_Required: 'Canal PWM LED requis',
    LED_Red_Required: 'Broche LED rouge requise',
    LED_Green_Required: 'Broche LED verte requise',
    LED_Yellow_Required: 'Broche LED jaune requise',
    Create_Success: 'Appareil créé avec succès',
    Error_Occurred: 'Une erreur est survenue',
    Update_Success: 'Appareil mis à jour avec succès',
    Device_Information: "Informations sur l'appareil",
    Device_Profile: "Profil d'appareil",
    Loading: 'Chargement...',
    Camera_Parameters: 'Paramètres de la caméra',
    Camera_Controls: 'Contrôles de caméra',
    RGB_Camera_Controls: 'Contrôles caméra RGB',
    RGB_Auto_Tuning: 'Réglage automatique RGB',
    RGB_Capture_Output: 'Sortie de capture RGB',
    RealSense_Capture_Output: 'Sortie de capture RealSense',
    Thermal_Capture_Output: 'Sortie de capture thermique',
    LED_Configuration: 'Configuration LED',
    RGB_Camera_FPS_Limit: 'Limite FPS caméra RGB',
    Brightness_Backend: 'Backend de luminosité',
    Brightness_Target: 'Cible de luminosité',
    Brightness_Target_Tolerance: 'Tolérance de cible de luminosité',
    Brightness_Percentile: 'Percentile de luminosité',
    Exposure_Time_Min_Us: "Temps d'exposition minimum (us)",
    Exposure_Time_Max_Us: "Temps d'exposition maximum (us)",
    Gain_Limit_Min: 'Limite de gain minimum',
    Gain_Limit_Max: 'Limite de gain maximum',
    Host_Auto_Skip_Frames: 'Images sautées côté hôte',
    Focus_Auto_Mode: 'Mode autofocus',
    Frame_Freshness_Timeout: 'Délai de fraîcheur image (ms)',
    Brightness_Region_Ratio: 'Ratio de région de luminosité',
    Focus_Region_Ratio: 'Ratio de région de mise au point',
    Focus: 'Mise au point',
    RGB_Capture_Extension: 'Extension de capture RGB',
    RGB_Capture_Quality: 'Qualité de capture RGB',
    RGB_Continuous_Encoding: 'Encodage continu RGB',
    RS_RGB_Capture_Quality: 'Qualité de capture RGB RealSense',
    RS_RGB_Continuous_Encoding: 'Encodage continu RGB RealSense',
    RS_Depth_Capture_Quality: 'Qualité de capture profondeur RealSense',
    RS_Depth_Continuous_Encoding: 'Encodage continu profondeur RealSense',
    Thermal_Capture_Quality: 'Qualité de capture thermique',
    Thermal_Continuous_Encoding: 'Encodage continu thermique',
    LED_PWMIntensity: 'Intensité LED',
    LED_PWMChip: 'Puce PWM LED',
    LED_PWMChannel: 'Canal PWM LED',
    LED_PWMFrequency: 'Fréquence PWM LED',
    LED_Red: 'Broche LED rouge',
    LED_Green: 'Broche LED verte',
    LED_Yellow: 'Broche LED jaune',
    RS_Camera_Enabled: 'Caméra RS activée',
    Thermal_Camera_Enabled: 'Caméra thermique activée',
    LED_Enabled: 'LED activée',
    Add_Device: 'Ajouter un appareil',
    Save_Changes: 'Enregistrer les modifications',
    Edit_Device: "Modifier l'appareil",
    API_HOST_URL: 'API Host URL',
    API_HOST_URL_Copied: 'API Host URL copiée dans le presse-papier',
    Copy_Host_URL: "Copier l'URL de l'hôte",
    Serial_Number_Tooltip: "Identifiant unique de l'appareil.",
    Name_Tooltip: "Nom de l'appareil.",
    Pitunnel_Device_Id_Tooltip: "Identifiant de l'appareil dans PiTunnel.",
    Device_Profile_Tooltip: "Identifiant du profil d'appareil associé à l'appareil.",
    API_HOST_URL_Tooltip: "URL de l'hôte API pour l'appareil.",
    RGB_Camera_FPS_Limit_Tooltip: 'FPS maximum de capture pour la caméra RGB.',
    Brightness_Backend_Tooltip: 'Backend de contrôle de luminosité pour la caméra RGB.',
    Brightness_Target_Tooltip: 'Luminosité cible pour la caméra RGB.',
    Brightness_Target_Tolerance_Tooltip: 'Écart autorisé autour de la luminosité cible.',
    Brightness_Percentile_Tooltip: "Percentile utilisé pour calculer la luminosité de l'image RGB.",
    Exposure_Time_Min_Us_Tooltip: "Temps d'exposition minimum de la caméra RGB en microsecondes.",
    Exposure_Time_Max_Us_Tooltip: "Temps d'exposition maximum de la caméra RGB en microsecondes.",
    Gain_Limit_Min_Tooltip: 'Gain minimum de la caméra RGB.',
    Gain_Limit_Max_Tooltip: 'Gain maximum de la caméra RGB.',
    Host_Auto_Skip_Frames_Tooltip: "Nombre d'images sautées côté hôte pendant les ajustements automatiques.",
    Focus_Auto_Mode_Tooltip: 'Mode autofocus utilisé par la caméra RGB.',
    Frame_Freshness_Timeout_Tooltip:
      "Âge maximum en millisecondes avant qu'une image RGB soit considérée comme périmée.",
    Brightness_Region_Ratio_Tooltip: "Ratio de zone d'image utilisé pour les calculs de luminosité.",
    Focus_Region_Ratio_Tooltip: "Ratio de zone d'image utilisé pour les calculs de mise au point.",
    Focus_Tooltip: 'Réglage manuel de la mise au point pour la caméra RGB.',
    RGB_Capture_Extension_Tooltip: 'Extension de fichier de sortie pour les captures RGB.',
    RGB_Capture_Quality_Tooltip: 'Qualité de sortie ou niveau de compression pour les captures RGB.',
    RGB_Continuous_Encoding_Tooltip: 'Indique si les images RGB sont encodées en continu.',
    RS_Camera_Enabled_Tooltip: 'Active ou désactive la caméra Realsense.',
    RS_RGB_Capture_Quality_Tooltip: 'Qualité de sortie pour les captures RGB RealSense.',
    RS_RGB_Continuous_Encoding_Tooltip: 'Indique si les images RGB RealSense sont encodées en continu.',
    RS_Depth_Capture_Quality_Tooltip: 'Niveau de compression PNG pour les captures de profondeur RealSense.',
    RS_Depth_Continuous_Encoding_Tooltip: 'Indique si les images de profondeur RealSense sont encodées en continu.',
    Thermal_Camera_Enabled_Tooltip: 'Active ou désactive la caméra thermique.',
    Thermal_Capture_Quality_Tooltip: 'Niveau de compression PNG pour les captures thermiques.',
    Thermal_Continuous_Encoding_Tooltip: 'Indique si les images thermiques sont encodées en continu.',
    LED_PWMIntensity_Tooltip: 'Intensité PWM utilisée pour la LED.',
    LED_PWMChip_Tooltip: 'Numéro de puce PWM utilisé pour la LED.',
    LED_PWMChannel_Tooltip: 'Numéro de canal PWM utilisé pour la LED.',
    LED_PWMFrequency_Tooltip: "Fréquence PWM utilisée pour contrôler l'intensité de la LED.",
    LED_Red_Tooltip: 'Numéro de broche GPIO pour la LED rouge.',
    LED_Green_Tooltip: 'Numéro de broche GPIO pour la LED verte.',
    LED_Yellow_Tooltip: 'Numéro de broche GPIO pour la LED jaune.',
    LED_Enabled_Tooltip: 'Active ou désactive la LED.',
  },
  DevicesList: {
    Serial_Number: 'Numéro de série',
    Device_Name: "Nom de l'appareil",
    Profile_Name: 'Nom du profil',
    Status_Update: 'Statut mise à jour',
    All: 'Tous',
    Online: 'En ligne',
    Offline: 'Hors ligne',
    Device_List_Title: 'Liste des appareils',
    Device_List_Heading: 'Liste des appareils',
    Dashboard: 'Tableau de bord',
    New_Device: 'Nouvel appareil',
    Rows_Per_Page: 'Lignes par page :',
    Dense: 'Dense',
    Search_Device_Name_Serial_Version: 'Rechercher par nom, numéro de série ou version',
  },
  DeviceDetails: {
    Select_Device_To_Display_Details: 'Sélectionnez un appareil pour afficher ses détails',
    Open_Terminal_In_New_Tab: 'Ouvrir le terminal dans un nouvel onglet',
    Terminal: 'Terminal',
    System_Information: 'Informations système',
    CPU_Usage: 'Utilisation CPU',
    Memory_Usage: 'Utilisation mémoire',
    Disk_Usage: 'Utilisation disque',
    CPU_Temperature: 'Température CPU',
    GPU_Temperature: 'Température GPU',
    Hostname: "Nom d'hôte",
    MAC_Address: 'Adresse MAC',
    Tunnels: 'Tunnels',
    Destination: 'Destination',
    No_Tunnels_Available: 'Aucun tunnel disponible.',
    Device_Offline_Info_Unavailable:
      "L'appareil est hors ligne. Les informations supplémentaires ne sont pas disponibles.",
    Loading: 'Chargement...',
    Camera_Not_Available: 'Caméra non disponible',
    Take_RGB_Photo: 'Prendre une photo RGB',
    Take_Depth_Photo: 'Prendre une photo de profondeur',
    Take_Thermal_Photo: 'Prendre une photo thermique',
    Autofocus_Adjustment: "Ajustement de l'autofocus",
    Autofocus_Adjustment_Info:
      "Lancer l'autofocus, enregistrer la valeur de focus retournée et capturer une nouvelle photo RGB",
    Autofocus_Adjustment_Failed: "Échec de l'ajustement de l'autofocus",
    Autofocus_Adjustment_Invalid_Focus: "L'ajustement de l'autofocus a retourné une valeur de focus invalide",
    Autofocus_Adjustment_Save_Failed: "Échec de l'enregistrement de la valeur d'autofocus",
    Photo_Capture_Failed: 'Échec de la capture de la photo',
    RGB: 'RGB',
    Depth: 'Profondeur',
    Thermal: 'Thermique',
    Restart_Device_Info: 'Redémarrer l’appareil ou le service',
    Restart: 'Redémarrer',
    Restart_Success: 'Redémarrage réussi',
    Restart_Failed: 'Échec du redémarrage',
    Select_Restart_Option: 'Sélectionnez une option de redémarrage',
    Backend: 'Backend',
    Controller: 'Contrôleur',
    Devices: 'Appareils',
    Copy_URL: 'Copier l’URL',
  },
  DevicesTableRow: {
    Edit: 'Modifier',
    Delete: 'Supprimer',
  },
  DeviceProfilesList: {
    ID: 'ID',
    Name: 'Nom',
    Description: 'Description',
    Version: 'Version',
    Heading: 'Profils d’appareil',
    New_Profile_Button: 'Nouveau profil',
    Edit: 'Modifier',
    Device_Profiles: 'Profils d’appareil',
    Search_Profile_Placeholder: 'Rechercher un profil par nom, description ou version...',
    Rows_Per_Page: 'Lignes par page',
    Dense: 'Compact',
  },
  DeviceProfilesCreate: {
    Create_Page_Title: 'Profil d’appareil : Création',
    Edit_Page_Title: 'Profil d’appareil : Édition',
    Create_Heading: 'Créer un profil d’appareil',
    Edit_Heading: 'Modifier le profil d’appareil',
    Name_Label: 'Nom',
    Description_Label: 'Description',
    Version_Label: 'Version de l’application',
    Version_Placeholder: 'ex : 1.0.0 ou v1.0.0',
    Name_Required: 'Le nom est requis',
    Description_Required: 'La description est requise',
    Version_Required: 'La version est requise',
    Version_Format_Invalid: 'Format de version invalide (ex : 1.0.0 ou v1.0.0)',
    Profile_Details: 'Détails du profil',
    Add_Profile_Button: 'Ajouter le profil',
    Save_Changes_Button: 'Enregistrer les modifications',
    Create_Success: 'Profil d’appareil créé avec succès',
    Update_Success: 'Profil d’appareil mis à jour avec succès',
  },
  CiqualItems: {
    Ciqual: 'Ciqual',
    Management_Title: 'Gestion des menus',
    List_Page_Title: 'Éléments Ciqual',
    List_Heading: 'Éléments Ciqual',
    Create_Page_Title: 'Élément Ciqual : création',
    Edit_Page_Title: 'Élément Ciqual : édition',
    Details_Page_Title: "Détails de l'élément Ciqual",
    Create_Heading: 'Créer un élément Ciqual',
    Edit_Heading: 'Modifier un élément Ciqual',
    Details_Heading: "Détails de l'élément Ciqual",
    Search_Placeholder: 'Rechercher par ID, code, nom officiel ou nom personnalisé...',
    Actions: {
      Add_Item: 'Ajouter un élément',
      View: 'Voir',
      Edit: 'Modifier',
      Duplicate: 'Dupliquer',
      Delete: 'Supprimer',
      Cancel: 'Annuler',
      Save_Changes: 'Enregistrer les modifications',
    },
    DeleteDialog: {
      Title: 'Supprimer un élément Ciqual',
      Description: 'Voulez-vous vraiment supprimer {{name}} ? Cette action est irréversible.',
    },
    Filters: {
      Is_Enabled: 'Est activé',
      All: 'Tous',
      True: 'Vrai',
      False: 'Faux',
    },
    Form: {
      General_Section: 'Informations générales',
      Classification_Section: 'Classification',
      Nutrition_Section: 'Nutrition pour 100 g',
    },
    Fields: {
      Id: 'ID',
      Alim_Code: 'Code CIQUAL',
      Alim_Nom_Fr: 'Nom officiel français',
      Alim_Nom_Fr_Custom: 'Nom français personnalisé',
      Used_In_Pipeline: 'Activé',
      Alim_Grp_Code: 'Code groupe',
      Alim_Ssgrp_Code: 'Code sous-groupe',
      Alim_Ssssgrp_Code: 'Code sous-sous-groupe',
      Alim_Grp_Nom_Fr: 'Nom du groupe',
      Alim_Ssgrp_Nom_Fr: 'Nom du sous-groupe',
      Alim_Ssssgrp_Nom_Fr: 'Nom du sous-sous-groupe',
      energy_kj: 'Énergie (kJ)',
      energy_kcal: 'Énergie (kcal)',
      protein_g: 'Protéines (g)',
      carbs_g: 'Glucides (g)',
      sugars_g: 'Sucres (g)',
      fat_g: 'Lipides (g)',
      sat_fat_g: 'Acides gras saturés (g)',
      fibre_g: 'Fibres alimentaires (g)',
      salt_g: 'Sel (g)',
    },
    Validation: {
      Alim_Code_Required: 'Le code CIQUAL est requis',
      Alim_Nom_Fr_Required: 'Le nom officiel français est requis',
      Number: 'Doit être un nombre',
      Integer: 'Doit être un entier',
    },
    Messages: {
      Create_Success: 'Élément Ciqual créé avec succès',
      Update_Success: 'Élément Ciqual mis à jour avec succès',
      Create_Error: "Erreur lors de la création de l'élément Ciqual",
      Update_Error: "Erreur lors de la mise à jour de l'élément Ciqual",
      Load_Error: "Erreur lors du chargement de l'élément Ciqual",
      Delete_Success: 'Élément Ciqual supprimé avec succès',
      Delete_Error: "Erreur lors de la suppression de l'élément Ciqual",
      Delete_Conflict: 'Cet élément Ciqual est référencé par d’autres enregistrements et ne peut pas être supprimé.',
    },
  },
  DishNutritionProfiles: {
    List_Page_Title: 'Profils nutritionnels des plats',
    List_Heading: 'Profils nutritionnels des plats',
    Details_Page_Title: "Détails du profil nutritionnel d'un plat",
    Details_Heading: 'Profil nutritionnel du plat',
    Search_Placeholder: 'Rechercher par ID, nom, nom normalisé ou type de plat...',
    Sections: {
      Profile: 'Profil',
      Nutrition: 'Nutrition pour 100 g',
      Components: 'Composants CIQUAL',
    },
    Fields: {
      Id: 'ID',
      Display_Name: "Nom d'affichage",
      Normalized_Name: 'Nom normalisé',
      Meal_Kind: 'Type de plat',
      Components: 'Composants',
      Energy_Kcal: 'Énergie (kcal/100 g)',
      Created_At: 'Créé le',
      Updated_At: 'Mis à jour le',
      Ciqual_Code: 'Code CIQUAL',
      Ciqual_Item: 'Élément CIQUAL',
      Proportion: 'Proportion',
      energy_kj_per_100g: 'Énergie (kJ/100 g)',
      energy_kcal_per_100g: 'Énergie (kcal/100 g)',
      protein_g_per_100g: 'Protéines (g/100 g)',
      carbs_g_per_100g: 'Glucides (g/100 g)',
      sugars_g_per_100g: 'Sucres (g/100 g)',
      fat_g_per_100g: 'Lipides (g/100 g)',
      sat_fat_g_per_100g: 'Acides gras saturés (g/100 g)',
      fibre_g_per_100g: 'Fibres alimentaires (g/100 g)',
      salt_g_per_100g: 'Sel (g/100 g)',
    },
    Messages: {
      Load_Error: 'Erreur lors du chargement du profil nutritionnel',
      No_Components: 'Aucun composant CIQUAL',
    },
  },
  Others: {
    Pending: 'En attente',
    In_Progress: 'En cours',
    Completed: 'Terminé',
    Dashboard: 'Dashboard',
    Loading: 'Chargement...',
    Error_Occurred: 'Une erreur est survenue, veuillez réessayer.',
    Rows_Per_Page: 'Lignes par page',
    Dense: 'Dense',
    View_Annotations: 'Voir les annotations',
    Hide_Not_Returned_BBoxes: 'Masquer les bboxes non retournées au client',
    Returned_To_Client: 'Retourné au client',
    Not_Returned_To_Client: 'Non retourné au client',
    Copy_BBox_ID: "Copier l'ID de la bbox",
    Validate_BBox: 'Valider la boîte',
    Unvalidate_BBox: 'Dévalider la boîte',
    BBox_ID_Copied: 'ID de la bbox copié',
    Detection_Score: 'Score de détection',
  },
  IdentificationToken: {
    Generate_Token_First: "Veuillez générer un token d'identification",
    Token_Copied: "Token d'identification copié dans le presse-papier",
    Identification_Title: 'Identification (Token)',
    Identification_Heading: "Générer un token d'identification",
    Admin: 'Admin',
    Expiration_Time: "Durée d'expiration (jours)",
    Generate_Token: "Générer un token d'identification",
    Click_To_Copy: 'Cliquez pour copier',
    Click_To_Download: 'Cliquez pour télécharger',
  },
  Selectors: {
    UsersSelector: 'Sélectionner un utilisateur',
  },
  LanguageSelector: {
    Languages: 'Langues',
    en: 'Anglais',
    fr: 'Français',
  },
  ResetPassword: {
    Password_No_Match: 'Les mots de passe ne sont pas identiques',
    Password_Too_Short: 'La mot de passe doit faire au moins 8 caractères',
    Success: 'Succès',
    Invalid_Token: 'Token invalide',
    Reset_Password: 'Réinitialisation du mot de passe',
    Password: 'Mot de passe',
    Confirm_Password: 'Confirmation du mot de passe',
    Confirm: 'Confirmer',
  },
  Login: {
    Invalid_Login: 'Identifiant ou mot de passe incorrect.',
    Successful_Login: 'Connexion réussie',
    Login_Instructions: 'Entrer un indentifiant et un mot de passe valides.',
    Username: 'Email',
    Enter_Username: "Entrer l'identifiant",
    Password: 'Mot de passe',
    Enter_Password: 'Entrer le mot de passe',
    Connect: 'Se connecter',
    Email_Must_Valid: "L'email doit être une adresse email valide",
    Email_Required: "L'email est requis",
    Password_Required: 'Mot de passe requis',
    Remember_Me: 'Se souvenir de moi',
  },
  Reporting: {
    Reporting_Title: 'Rapports : Quotidien',
    Reporting_Heading: 'Rapports',
    Reporting: 'Rapports',
    Daily: 'Quotidien',
    Total_Trays: 'Total des plateaux',
    Total_Tickets: 'Total des tickets',
    Wrong_Trays: 'Plateaux erronés',
    Perc_Of_Good_Trays: '% de plateaux corrects (net)',
    Perc_Of_Good_Trays_Live: '% de plateaux corrects (brut)',
    Product_Name: 'Nom du produit',
    Object_Class: "Type d'objet (détection)",
    Precision: 'Précision',
    Recall: 'Rappel',
    F1_Score: 'Score F1',
    TP_Description: "Vrai Positif :\nNombre d'articles correctement identifiés.",
    FP_Description:
      "Faux Positif :\nNombre d'articles incorrectement identifiés. Nous avons prédit que l'article était présent, mais il ne l'était pas.",
    FN_Description:
      "Faux Négatif :\nNombre d'articles non identifiés. Nous avons prédit que l'article n'était pas présent, mais il l'était.",
    Precision_Description: 'Précision : Proportion des articles prédits qui sont effectivement présents.',
    Recall_Description: 'Rappel : Proportion des articles réels qui sont prédits.',
    F1_Score_Description: 'Score F1 : La moyenne harmonique de la précision et du rappel.',
    Statistics_Per_Product: 'Statistiques par produit',
    ObjectClasses_To_Remove: "Types d'objets à retirer",
  },
  ReportingSummaryCSI: {
    Dashboard: 'Tableau de bord',
    Reporting: 'Rapports',
    Breadcrumb: 'Résumé CSI',
    Page_Title: 'Rapports : Résumé CSI',
    Page_Heading: 'Rapports : Résumé CSI',
    From_Date: 'Date de début',
    To_Date: 'Date de fin',
    Restaurants_Label: 'Restaurants CSI',
    Select_All_Restaurants: 'Sélectionner tous les restaurants',
    Restaurants_Placeholder: 'Sélectionner des restaurants',
    Submit: 'Valider',
    Table_Restaurant: 'Nom',
    Table_Restaurant_Id: 'ID',
    No_CSI_Restaurants: "Aucun restaurant CSI n'est disponible pour votre compte.",
    Invalid_Date_Range: 'La date de début doit être antérieure ou égale à la date de fin.',
    Weekends_Excluded_Note: 'Les week-ends sont exclus des dates du reporting CSI.',
    Select_At_Least_One_Restaurant: 'Sélectionnez au moins un restaurant CSI.',
    Error_Loading_Data: 'Erreur lors du chargement du reporting de synthèse.',
    No_Results: 'Aucun résultat pour les filtres sélectionnés.',
    No_Results_Click_Submit: 'Aucun résultat pour le moment. Cliquez sur Valider pour récupérer les données.',
  },
  RestaurantList: {
    Restaurant_Title: 'Restaurants',
    Restaurant_Heading_List: 'Restaurants',
    New_Restaurant: 'Nouveau restaurant',
    TableHead: {
      Search_Restaurant: 'Rechercher un restaurant...',
      Choose_Country: 'Choisir un pays',
      Is_Active: 'Actif',
      Project: 'Projet',
    },
    TableRow: {
      Id: 'ID',
      Name: 'Nom',
      Alias_Name: "Nom d'alias",
      Project: 'Projet',
      City: 'Ville',
      Group_Name: 'SRC',
      Cash_Sys_Name: "Système d'encaissement",
      Country: 'Pays',
      Active: 'Actif',
      Inactive: 'Inactif',
      Health: 'Santé',
      Checkout: 'Encaissement',
    },
  },
  RestaurantCreate: {
    Restaurant_Title: 'Restaurants',
    Restaurant_Heading_Add: 'Ajouter un restaurant',
    Restaurant_Heading_Edit: 'Modifier un restaurant',
    Restaurant: 'Restaurant',
    Restaurant_Added_Success: 'Restaurant ajouté avec succès !',
    Restaurant_Updated_Success: 'Restaurant mis à jour avec succès !',
    Restaurant_Save_Error: "Erreur lors de l'enregistrement du restaurant",
    FormFields: {
      Name: 'Nom',
      Alias_Name: "Nom d'alias",
      Project: 'Projet',
      City: 'Ville',
      Restaurant_Group: 'SRC',
      Cash_System: "Système d'encaissement",
      Address: 'Adresse',
      Zip_Code: 'Code postal',
      Country: 'Pays',
      Is_Active: 'Actif',
      Hide_Mode: 'Mode masqué',
      Use_Qrcode_Reader: 'Utiliser le lecteur QR code',
      Kiosk_Type: 'Type de kiosque',
      No_Kiosk_Type: 'Aucun type de kiosque',
      Health: 'Santé',
      Checkout: 'Encaissement',
      TrayHealth_Settings: 'Paramètres TrayHealth',
      TrayScan_Settings: 'Paramètres TrayScan',
      Use_Llm_Analysis: "Utiliser l'analyse LLM",
      Use_Counting_Analysis: "Utiliser l'analyse de comptage",
      Authorized_Users: 'Utilisateurs autorisés',
      Create_Restaurant: 'Créer un restaurant',
      Save_Changes: 'Sauvegarder les changements',
    },
  },
  ApiDocumentation: {
    Copy_Doc: 'Copier la doc OpenAPI (JSON)',
    Cash_System_Selector: "Sélectionner un système d'encaissement",
    Doc_Copied: 'Documentation copiée',
  },
  Components: {
    BlockContent: {
      Drop_Or_Select_File: 'Déposer ou sélectionner un fichier',
      Drop_File_Or_Click: 'Déposez les fichiers ici ou cliquez pour',
      Browse: 'parcourir',
      Thorough_Your_Machine: 'vos fichiers.',
    },
    DeleteDialog: {
      Are_You_Sure: 'Êtes-vous certains de vouloir supprimer ',
      Product: 'produit',
      Action_Cannot_Undone: 'Cette action sera définitive.',
    },
    MergeDialog: {
      Are_You_Sure: 'Êtes-vous certains de vouloir fusionner ',
      Product: 'produit',
      Action_Cannot_Undone: "L'action est irréversible !",
      Merge: 'Fusionner',
    },
  },
  Clients: {
    Clients_Title: 'Clients',
    Clients_Heading_List: 'Liste des clients',
    New_Client: 'Nouveau client',
    TableToolbar: {
      Search_Client: 'Rechercher un client...',
    },
    TableHead: {
      Id: 'ID',
      Client_Hash: 'Client Hash',
      Restaurant: 'Restaurant',
      Status: 'Status',
    },
    Form: {
      ClientHash: 'Client Hash',
      ClientHash_Required: 'Le hash du client est requis',
      ActiveStatus: 'Statut actif',
      Status_Required: 'Le statut est requis',
      Create_Client: 'Créer un client',
      Save_Changes: 'Sauvegarder les changements',
      Client_Created_Success: 'Client créé avec succès !',
      Client_Updated_Success: 'Client mis à jour avec succès !',
    },
  },
  HealthMenu: {
    // Main sections
    Management_Title: 'Gestion des Menus',
    Menu_Title: 'Menus',
    Menu_Heading: 'Menus',

    // Common actions (reused across health menu components)
    Actions: {
      Add: 'Ajouter',
      Edit: 'Modifier',
      Delete: 'Supprimer',
      Cancel: 'Annuler',
      Save_Changes: 'Enregistrer les Modifications',
      Add_Product: 'Ajouter un Produit',
      Edit_Product: 'Modifier le Produit',
    },

    // Common form fields
    Fields: {
      Name: 'Nom',
      Description: 'Description',
      Type: 'Type',
      Menu_Type: 'Type de menu',
      Date: 'Date',
      Meal_Time: 'Heure du Repas',
      Menu_Document: 'Document du menu',
      Dish_Profile: 'Profil de plat',
      Substitution: 'Menu de substitution',
    },

    // Validation messages
    Validation: {
      Name_Required: 'Le nom est obligatoire',
      Type_Required: 'Le type est obligatoire',
      Menu_Type_Required: 'Le type de menu est obligatoire',
      Meal_Time_Required: "L'heure du repas est obligatoire",
      Must_Be_Greater_Than_Zero: 'Doit être supérieur ou égal à 0',
    },

    // Table interface
    Table: {
      Search_Product: 'Rechercher un produit...',
      Search_Category: 'Rechercher une catégorie...',
      Dense: 'Compact',
      Rows_Per_Page: 'Lignes par page',
      Loading_Menu_Items: 'Chargement des éléments du menu...',
    },

    // Status messages
    Messages: {
      Success_Adding: 'Produit ajouté avec succès',
      Success_Creating: 'Produit créé avec succès',
      Success_Updating: 'Produit mis à jour avec succès',
      Success_Deleting: 'Produit supprimé avec succès',
      Error_Adding: "Erreur lors de l'ajout du produit",
      Error_Creating: 'Erreur lors de la création du produit',
      Error_Updating: 'Erreur lors de la mise à jour du produit',
      Error_Deleting: 'Erreur lors de la suppression du produit',
      No_Data_Found: 'Aucune donnée trouvée pour',
      No_Type: 'Pas de type',
      No_Description: 'Pas de description',
      No_Menus_Found: 'Aucun menu trouvé',
      No_Menus_For_Restaurant: 'Aucun menu pour ce restaurant',
      Select_Restaurant_To_View_Menus: 'Sélectionnez un restaurant pour afficher les menus',
    },

    // Common values
    Common: {
      Yes: 'Oui',
      No: 'Non',
    },

    // Nutritional information
    Nutrition: {
      Nutritional_Values: 'Valeurs Nutritionnelles',
      Has_Nutritional_Values: 'A des Valeurs Nutritionnelles',
      Total_Fat: 'Lipides',
      Sat_Fat: 'Acides gras saturés',
      Protein: 'Protéines',
      Sodium: 'Sodium',
      Calcium: 'Calcium',
      Cho: 'Glucides',
      Sugars: 'Sucre',
      Diet_Iron: 'Fer',
      Diet_Fibre: 'Fibre alimentaire',
      Kcal: 'Énergie',
      Net_Weight: 'Poids net',
      Gross_Weight: 'Poids brut',
    },

    // Category-specific
    Category: {
      Page_Title: 'Catégories de Menus',
      Page_Heading: 'Catégories de Menus',
      Add_Menu_Category: 'Ajouter une Catégorie de Menu',
      Edit_Menu_Category: 'Modifier le Menu',
      Is_Substitution: 'Menu de Substitution',
      Success_Adding: 'Ajouté avec succès',
      Success_Updating: 'Mis à jour avec succès',
      Error_Adding: "Erreur lors de l'ajout",
      Error_Updating: 'Erreur lors de la mise à jour',
    },

    // File import
    Import: {
      Page_Title: 'Importer des fichiers de menu',
      Page_Heading: 'Importer des fichiers de menu',
      Upload_Section_Title: 'Uploader un menu',
      Upload_Helper_Text: 'Glissez vos fichiers ici ou cliquez pour parcourir votre machine',
      Select_Categories_Title: 'Sélectionner les catégories de menus présentes :',
      Select_Dates_Title: 'Sélectionner les dates de validité du menu :',
      Start_Date_Label: 'Date de début',
      End_Date_Label: 'Date de fin',
      Submit_Button: 'Pré-Remplir le menu',
      Success_Message: 'Fichier téléchargé avec succès',
      Error_No_Categories: 'Veuillez sélectionner au moins une catégorie de menu',
      Error_No_Restaurant: 'Veuillez sélectionner un restaurant pour importer des fichiers de menu.',
      Error_No_Categories_Available:
        "Aucune catégorie de menu trouvée. Veuillez créer des catégories de menu avant d'importer des fichiers.",
      Loading_Categories: 'Chargement des catégories de menu...',
      Error_Loading_Categories: 'Erreur lors du chargement des catégories de menu :',
      Validation: {
        Start_Date_Required: 'La date de début est requise',
        End_Date_Required: 'La date de fin est requise',
        File_Required: 'Le fichier est requis',
        Only_PDF_Files_Allowed: 'Seuls les fichiers PDF sont autorisés',
      },
    },

    // Documents Status
    Documents: {
      // Page information
      Page_Title: 'Statut des Fichiers',
      Page_Heading: 'Statut des Fichiers',

      // Table fields
      Fields: {
        ID: 'ID',
        Upload_Datetime: 'Date de téléchargement',
        Status: 'Statut',
        UUID: 'UUID',
        Processed_Datetime: 'Date de traitement',
        Date_Range: 'Plage de dates',
      },

      // Status labels
      Status: {
        All: 'Tous',
        Queued: 'En attente',
        Processing: 'En cours',
        Processed: 'Traité',
        Error: 'Erreur',
      },

      // Actions
      Actions: {
        Download: 'Télécharger',
        Download_Selected: 'Télécharger les Fichiers Sélectionnés',
        Reprocess: 'Retraiter',
        Delete: 'Supprimer',
      },

      Delete_Confirmation: {
        Title: 'Supprimer le document du menu ?',
        Description:
          'Cette action supprimera définitivement {{filename}} et tous les éléments de menu extraits, y compris les analyses liées. Cette action est irréversible.',
      },

      // Table interface
      Table: {
        Search_Document: 'Rechercher un document...',
        Dense: 'Compact',
        Rows_Per_Page: 'Lignes par page',
      },

      // Messages
      Messages: {
        Loading: 'Chargement...',
        Error_Loading: 'Erreur lors du chargement des données',
        Download_Success: 'Téléchargement réussi',
        Download_Error: 'Erreur lors du téléchargement',
        Reprocess_Success: 'Retraitement du document lancé avec succès',
        Reprocess_Error: 'Erreur lors du retraitement du document',
        Delete_Success: 'Document supprimé avec succès',
        Delete_Error: 'Erreur lors de la suppression du document',
        Bulk_Download_Success: '{{count}} fichier(s) téléchargé(s) avec succès',
        Bulk_Download_Partial_Error: '{{errorCount}}/{{totalCount}} fichiers ont échoué',
        Bulk_Download_Error: 'Erreur lors du téléchargement des fichiers sélectionnés',
      },
    },

    // Prompt Editor
    PromptEditor: {
      // Page information
      Page_Title: 'Éditeur de Prompt',
      Page_Heading: 'Éditeur de Prompt',

      // Form sections
      Upload_Section_Title: 'Télécharger un menu',
      Select_Categories_Title: 'Sélectionner les catégories de menu',
      Select_Dates_Title: 'Sélectionner les dates de début et de fin',
      Prompt_Section_Title: 'Configuration du modèle et des prompts',

      // Form labels
      From_Date_Label: 'Date de début',
      To_Date_Label: 'Date de fin',
      Model_Label: 'Modèle',
      System_Prompt_Label: 'Prompt Système',
      User_Prompt_Label: 'Prompt Utilisateur',

      // Placeholders
      System_Prompt_Placeholder: 'Entrez le prompt système...',
      User_Prompt_Placeholder: 'Entrez le prompt utilisateur...',

      // Buttons
      Run_Processing_Button: 'Lancer le Traitement',
      Save_Button: 'Enregistrer le Prompt',
      Update_Button: 'Mettre à jour le Prompt',

      // Results
      Results_Title: 'Résultats',
      Json_View_Title: 'Vue JSON',
      Table_View_Title: 'Vue Tableau',
      Processing_Message: 'Traitement de votre requête...',
      Processing_Status: 'Statut actuel : {{status}}',
      Copy_Success: 'Copié dans le presse-papier !',
      Copy_Error: 'Échec de la copie dans le presse-papier',

      // Messages
      Success_Message: 'Test du prompt terminé avec succès',
      Save_Success: 'Prompt enregistré avec succès',
      Update_Success: 'Prompt mis à jour avec succès',
      Timeout_Message: 'Le test du prompt a expiré après 5 minutes. Veuillez réessayer plus tard.',
      Error_Start_Test: 'Erreur lors du lancement du test du prompt',
      Error_Polling_Result: 'Erreur lors de la récupération du résultat du test du prompt',
      Error_Unexpected_Response: 'Réponse inattendue du test du prompt',
      Error_No_Categories: 'Veuillez sélectionner au moins une catégorie de menu',
      Error_No_Restaurant: 'Aucun restaurant sélectionné',
      Error_No_Categories_Available:
        'Aucune catégorie de menu disponible. Veuillez créer des catégories de menu en premier.',
      Loading_Categories: 'Chargement des catégories de menu...',
      Error_Loading_Categories: 'Erreur lors du chargement des catégories de menu :',

      // Validation messages
      Validation: {
        From_Date_Required: 'La date de début est requise',
        To_Date_Required: 'La date de fin est requise',
        File_Required: 'Le fichier est requis',
        File_Type_Error: 'Seuls les fichiers PDF et image sont autorisés',
        System_Prompt_Required: 'Le prompt système est requis',
        User_Prompt_Required: 'Le prompt utilisateur est requis',
        Model_Required: 'Le modèle est requis',
      },
    },
  },
};
